import { MsgTemplateArguments, msgTmpl } from "../i18n/messages"
import { formatAnyAsHtml } from "../utils/format"
import { isObject, isString } from "../utils/utils"
import { useOmniaContext } from "./context"

type Props =
    | {
        children: React.ReactNode;
        text?: never;
        args?: never;
        debug?: boolean
        format?: boolean
    }
    | {
        /**
         * A format string of text to insert. May contain `{{foo}}` to replace with `args.foo`.
         */
        text: string;
        /**
         * Variables to insert into the `text` format string.
         */
        args?: MsgTemplateArguments;
        children?: never;

        debug?: boolean
        format?: boolean

    };

export function Msg({ text, args, debug, format, children }: Props) {

    const { i18n } = useOmniaContext()

    text = text ?? (children && isString(children) ? children : undefined)

    if (text && isString(text) && isObject(args)) {
        text = msgTmpl(text, args)
    }

    if (!text) {
        return <>{children}</>
    }

    const { msg, found } = i18n.getMessage(text)

    if (!found) {

        if (debug) {
            console.log("i18n: message not found", text)
        }

        return <span className="omt omt-notfound">(?{msg ?? text})</span>

    }

    else if (format) {

        return <span className="omt omt-ok" dangerouslySetInnerHTML={{ __html: formatAnyAsHtml(msg) }} />

    }
    else {

        return <span className="omt omt-ok">{msg}</span>

    }

}

export function MsgFormat(props: Props) {
    props = { ...props, format: true }
    return <Msg {...props} />
}
